import { addListener } from "@grindex-common/helpers/domManipulation";
import { $elementChild, $elementChildren } from "@grindex-common/helpers/elements";
import { constants } from "@grindex-components/Accordion/Accordion.constants";
import { Resolution } from "@grindex-common/helpers/Resolution.class";
import { events } from "@grindex-common/helpers/events";
import asyncModule from "@grindex-client/components/Module/asyncModule";

(function listenForEvent() {
	asyncModule("accordion", events.TAB_ALL_LOADED, init);
})();

function init($views) {
	let $accordionItems = [];
	const resolution = new Resolution();
	var targetResolution;
	if ($views.length) {
		targetResolution = $views[0].dataset.accordionBreakpoint;

		$views.forEach(($view) => {
			var $items = Array.from($elementChildren($view, constants.ELEMENT_ACCORDION_ITEM));
			filterItemsForCurrentAccordion($view, $items);
			$accordionItems = $accordionItems.concat($items);

			bindItems($accordionItems);
		});
	} else {
		targetResolution = $views.dataset.accordionBreakpoint;

		$accordionItems = Array.from($elementChildren($views, constants.ELEMENT_ACCORDION_ITEM));
		filterItemsForCurrentAccordion($views, $accordionItems);

		bindItems($accordionItems);
	}

	function filterItemsForCurrentAccordion($view) {
		$accordionItems = $accordionItems.filter(($item) => {
			return $item.closest("[xyl-async-view='accordion']") === $view;
		});
	}

	function bindItems($items) {
		[...$items].forEach(($accordionItem) => {
			$accordionItem.classList.add(constants.CLASS_ACCORDION_ROOT);
			if ($accordionItem && $accordionItem.querySelector(constants.SELECTOR_EXPANDABLE_CONTENT)) {
				const $trigger = $elementChild($accordionItem, constants.SELECTOR_TRIGGER);

				if ($trigger) {
					$trigger.removeEventListener("click", toggle);
					addListener($trigger, "click", toggle);
				}
			}
		});
	}

	function toggle(evt) {
		// Only handle accordion functionality when below given breakpoint
		if (!resolution.isLessThan(resolution.devices[targetResolution])) {
			return;
		}

		const $currentItem = evt.target.closest("[xyl-element='accordion-item']");
		const isExpanded = $currentItem.classList.contains(constants.CLASS_ACTIVE);
		[...$accordionItems].forEach(($accordionItem) => {
			$accordionItem.classList.remove(constants.CLASS_ACTIVE);
		});

		if (isExpanded) {
			$currentItem.classList.remove(constants.CLASS_ACTIVE);
		} else {
			$currentItem.classList.add(constants.CLASS_ACTIVE);
		}
	}
}

export default {
	view: "accordion",
	init,
};
